import React from 'react';
import { useSelector } from 'react-redux';

// import selectors
import { getTranslationById } from 'js/store/app/App.selectors';
import { getUserCollections } from 'js/store/collections/Collections.selectors';

// import constants
import { STATES } from './Collection.model';

// import components
import CollectionAddRemoveCarousel from 'js/components/collections/Collections.add-remove-carousel';
import ButtonWithIcon from 'js/components/button/Button.with-icon';

const CollectionAdd = ({ card, switchState, closeModal }) => {
  const siteText = {
    addToGallery: useSelector((state) => getTranslationById(state, 'overlay_popup_add_to_gallery', 'Add to Gallery')),
    createNewGalleryButtonText: useSelector((state) =>
      getTranslationById(state, 'overlay_popup_create_new_gallery_button_text', 'Create New Gallery')
    ),
    alreadySavedIn: useSelector((state) =>
      getTranslationById(state, 'overlay_popup_already_saved_in', 'Already saved in')
    ),
    saveIn: useSelector((state) => getTranslationById(state, 'overlay_popup_save_in', 'Save in')),
    imDoneButtonText: useSelector((state) =>
      getTranslationById(state, 'overlay_popup_im_done_button_text', "I'm done")
    ),
  };
  const userCollectionNames = useSelector((state) => getUserCollections(state).map((collection) => collection.name));

  return (
    <div className="collection-modal__add">
      <h1 style={{ marginBottom: 30 }}>{siteText.addToGallery}</h1>
      {userCollectionNames.length < 5 && (
        <ButtonWithIcon
          title={siteText.createNewGalleryButtonText}
          iconName={'add'}
          iconPosition={'right'}
          action={() => switchState(STATES.CREATE)}
          style={{ margin: '0 auto 30px', padding: '15px 15px 15px 50px' }}
        />
      )}

      <CollectionAddRemoveCarousel card={card} type={'saved-in'} title={siteText.alreadySavedIn} />
      <CollectionAddRemoveCarousel card={card} title={siteText.saveIn} />

      <ButtonWithIcon
        title={siteText.imDoneButtonText}
        iconName={'tick'}
        iconPosition={'right'}
        style={{
          backgroundColor: '#9DC145',
          borderRadius: '36px',
          margin: 'auto',
          padding: '15px 25px 15px 50px',
          fontSize: 14,
        }}
        action={closeModal}
      />
    </div>
  );
};

export default CollectionAdd;
